import styled from "styled-components";

export const FlexWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`